import React from 'react'
import PageLayout from '../PageLayout'
import InstancepartsTable from './InstancepartsTable'

// const useStyles = makeStyles(theme => ({
//     content: {
//        //
//     },
// }))


export default function AppInstancepartsPage() {
    // const classes = useStyles()

    // console.log('AppInstancepartsPage render')

    return (
        <PageLayout>
            <InstancepartsTable />
        </PageLayout>
    )
}

